import React, { Component, PropTypes } from 'react';
import _ from 'underscore';

import Button from '../elements/Button';
import TextInputGroup from '../elements/TextInputGroup';
import FileInputGroup from '../elements/FileInputGroup';

class ProfileSchoolUpdateForm extends Component {
    constructor(props, context) {
        super(props, context);

        const school = props.profile.school;
        this.state = {
            full_name: props.profile.profile.full_name,
            title: school.title,
            featured_image: '',
            address_1: school.address_1,
            address_2: school.address_2,
            city: school.city,
            county: school.county,
            postcode: school.postcode,
            phone_number: props.profile.profile.phone_number,
            email: props.profile.email,
        };
    }

    handleSubmit = (e) => {
        e.preventDefault();

        const { name } = this.state;

        if (!_.isNull(name)) {
            this.props.handleSubmit(this.state);
        }
    };

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <TextInputGroup
                    name="name"
                    label="Full name"
                    placeholder="Your full name"
                    value={this.state.full_name}
                    onChange={e => this.setState({ full_name: e.target.value })}
                    toolTip="E.g. John Doe" />
                <TextInputGroup
                    name="title"
                    label="School name"
                    placeholder="The name of your school"
                    value={this.state.title}
                    onChange={e => this.setState({ title: e.target.value })}
                    toolTip="E.g. Dunraven Primary School" />
                <FileInputGroup
                    name="featured_image"
                    label="School logo"
                    value={this.state.featured_image}
                    onChange={value => this.setState({ featured_image: value })}
                    toolTip="A jpeg or png image of your school logo" />
                <TextInputGroup
                    name="address_1"
                    label="School address"
                    placeholder="First line"
                    value={this.state.address_1}
                    onChange={e => this.setState({ address_1: e.target.value })}
                    toolTip="E.g. The primary address of your school" />
                <TextInputGroup
                    name="address_2"
                    label={null}
                    placeholder="Second line"
                    value={this.state.address_2}
                    onChange={e => this.setState({ address_2: e.target.value })} />
                <TextInputGroup
                    name="city"
                    label={null}
                    placeholder="City"
                    value={this.state.city}
                    onChange={e => this.setState({ city: e.target.value })} />
                <TextInputGroup
                    name="county"
                    label={null}
                    placeholder="County"
                    value={this.state.county}
                    onChange={e => this.setState({ county: e.target.value })} />
                <TextInputGroup
                    name="postcode"
                    label={null}
                    placeholder="Postcode"
                    value={this.state.postcode}
                    onChange={e => this.setState({ postcode: e.target.value })} />
                <TextInputGroup
                    name="phone_number"
                    label="Phone number"
                    placeholder="Your phone number"
                    value={this.state.phone_number}
                    onChange={e => this.setState({ phone_number: e.target.value })}
                    toolTip="The best telephone number to reach you on in working hours." />
                <TextInputGroup
                    name="email"
                    label="Your email address"
                    placeholder="Your email address"
                    value={this.state.email}
                    onChange={e => this.setState({ email: e.target.value })}
                    toolTip="Make sure you use your school email address so we can verify you. E.g. jane.smith@schoolname.sch.uk " />
                <p>
                    <Button>
                        <p>Submit</p>
                    </Button>
                </p>
            </form>
        );
    }
}

ProfileSchoolUpdateForm.propTypes = {
    profile: PropTypes.object,
    handleSubmit: PropTypes.func.isRequired
};

module.exports = ProfileSchoolUpdateForm;



/** WEBPACK FOOTER **
 ** ./src/forms/ProfileSchoolUpdateForm.js
 **/